module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"passwordChanged":"Password changed successfully. You will now be redirected to the login page...","considerChangingPassword":"<i>We have updated our password security policy. For your own safety, you need to change your password.</i>","currentPassword":"Current Password","newPassword":"New Password","newPasswordRepeat":"New Password (Again)"}}')
  delete Component.options._Ctor
}
